import type { VoteReviewBodyVote } from './voteReviewBodyVote';

/**
 * 리뷰 투표 요청
 */
export type VoteReviewBody = {
  /** 투표 유형 */
  vote: VoteReviewBodyVote;
};
